import React, { useState } from 'react';
import './notificationDetails.css';
import default_image from '../../assets/images/notice_image.png';
import { Col, Row } from 'react-bootstrap';
import DateRangePicker from './dateRangePicker';
import { FaRegCalendarAlt } from 'react-icons/fa';
const notifications = [
  {
    id: 1,
    date: '21 July, 2022',
    title: 'Cursus quam vel odio',
    subtitle:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et eu egestas augue sem habitasse elit, mauris mattis massa. Sollicitudin lacus rhoncus.',
    time: '30 mins Ago',
    status: 'new',
  },
  {
    id: 2,
    date: '17 July, 2022',
    title: 'Sollicitudin lacus rhoncus.',
    subtitle:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa. Sollicitudin lacus rhoncus.',
    time: '',
    status: 'dot',
  },
  {
    id: 3,
    date: '17 July, 2022',
    title: 'Est eu egestas augue',
    subtitle:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fringilla euismod fermentum vestibulum, diam ut phasellus. Morbi posuere egestas cursus consectetur odio elementum justo, vel suspendisse. Pellentesque semper neque metus.',
    time: '',
    status: 'none',
  },
];

const grouped = notifications.reduce((acc, cur) => {
  acc[cur.date] = acc[cur.date] || [];
  acc[cur.date].push(cur);
  return acc;
}, {});

const NotificationDetails = () => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  const handleDateChange = (range) => {
    setDateRange({
      startDate: range.startDate,
      endDate: range.endDate,
    });
  };

  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Newest First");

  const sortOptions = ["Newest First", "Oldest", "Unread", "Read"];

  const handleSortChange = (option) => {
    setSelectedSort(option);
    setShowSortDropdown(false);
  }

  const [selectedFilter, setSelectedFilter] = useState("All");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  return (
    <div className="fluid-container notificationdetails" style={{ minHeight: '600px' }}>
      <div className="breadcrumb-wrapper">
        <p>Notifications</p>
        <div>
          <span className="title">Dashboard</span>
          <span> / </span>
          <span className="mark-read">Notifications</span>
        </div>
      </div>
      <br />
      <Col md={10} className="notificationdetails-card">
        <div className="notification-card-header">
          <h5>
            Notifications <span className="notif-count">3</span>
          </h5>
          <div className="controls">
            <div className="notificationdetailsdropdown-wrapper">
              <button
                className="btn-sort"
                onClick={() => setShowSortDropdown((prev) => !prev)}
              >
                {selectedSort}
              </button>

              {showSortDropdown && (
                <div className="notificationdetailsdropdown-menu-sort">
                  {sortOptions.map((option) => (
                    <div
                      key={option}
                      className={`notificationdetailsdropdown-item-sort ${selectedSort === option ? "active" : ""}`}
                      onClick={() => handleSortChange(option)}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="calendar-selection-dropdown-wrapper">
              <button
                className="btn-filter"
                onClick={() => setShowFilterDropdown((prev) => !prev)}
              >
                {selectedFilter}
                <span
                  className="btn-calendar-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (selectedFilter === "Custom") {
                      setShowCalendar((prev) => !prev);
                    }
                  }}
                >
                  <FaRegCalendarAlt size={16} style={{ marginLeft: 8 }} />
                </span>
              </button>

              {showFilterDropdown && (
                <div className="calendar-selection-dropdown-menu-filter">
                  {["All", "Today", "Last 7 Days", "Custom"].map((item) => (
                    <div
                      key={item}
                      className={`calendar-selection-dropdown-item-filter ${selectedFilter === item ? "active" : ""}`}
                      onClick={() => {
                        setSelectedFilter(item);
                        setShowCalendar(false);
                        setShowFilterDropdown(false);

                        if (item === "Today") {
                          const today = new Date();
                          handleDateChange({ startDate: today, endDate: today });
                        }

                        if (item === "Last 7 Days") {
                          const end = new Date();
                          const start = new Date();
                          start.setDate(end.getDate() - 6);
                          handleDateChange({ startDate: start, endDate: end });
                        }
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              )}

              {showCalendar && selectedFilter === "Custom" && (
                <div className="calendar-wrapper">
                  <DateRangePicker
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                    onChange={handleDateChange}
                    onClose={() => setShowCalendar(false)}
                  />
                </div>
              )}

            </div>

          </div>
        </div>
        <hr />

        {Object.keys(grouped).map((date) => (
          <div key={date} className="date-group">
            <h6>{date}</h6>
            {grouped[date].map((n) => (
              <div className="notification-item" key={n.id}>
                <img className="notif-avatar" src={default_image} alt="avatar" />
                <div className="notif-content">
                  <div className="notif-title d-flex align-items-center gap-1 flex-wrap">
                    <strong className="mb-0">{n.title}</strong>
                    {n.time && <span className="notif-time">| {n.time}</span>}
                    {n.status === 'new' && <span className="badge-new ms-auto">New</span>}
                    {n.status === 'dot' && <span className="dot ms-auto" />}
                  </div>
                  <div className="notif-subtitle">{n.subtitle}</div>
                </div>
              </div>

            ))}
            <hr />

          </div>
        ))}
      </Col>
    </div>
  );
};

export default NotificationDetails;
